export default __webpack_public_path__ + "static/hinduja-logo-mahim-52f9de820a68b8a7a8a8d46ad04ff0d1.svg";